@if (dashboardModel.bbAdminDashboardVisible) {
  <div class="analytics-dashboard">
    <header class="analytics-dashboard__intro">
      <div>
        <p class="analytics-dashboard__eyebrow">{{ dashboardModel.dashboardRoleLabel }}</p>
        <h2 class="analytics-dashboard__title">BounceBack at a glance</h2>
        <p class="analytics-dashboard__subtitle">Metrics, invitations, and shortcuts based on your access.</p>
      </div>
      @if (showHeroStat) {
        <div class="analytics-dashboard__hero-stat">
          <span class="analytics-dashboard__hero-label">BB participants</span>
          <span class="analytics-dashboard__hero-value">{{ totalBbParticipants | number }}</span>
        </div>
      }
    </header>
    @if (visiblePlatformMetrics.length) {
      <section
        class="analytics-dashboard__stats-row"
        [class.analytics-dashboard__stats-row--compact]="visiblePlatformMetrics.length <= 3"
        aria-label="BounceBack metrics"
        >
        @for (metric of visiblePlatformMetrics; track metric) {
          <article
            class="stat-tile"
            [class]="'stat-tile stat-tile--' + metric.accent">
            <div class="stat-tile__body">
              <span class="stat-tile__value">{{ metric.getValue(dashboardModel.analytics) | number }}</span>
              <span class="stat-tile__label">{{ metric.label }}</span>
            </div>
            <mat-icon class="stat-tile__icon">{{ metric.icon }}</mat-icon>
          </article>
        }
      </section>
    }
    @if (visibleQuickLinks.length) {
      <div class="analytics-dashboard__divider" role="separator">
        <span>Quick access</span>
      </div>
    }
    @if (visibleQuickLinks.length) {
      <section class="quick-links" aria-label="Quick access links">
        @for (link of visibleQuickLinks; track link) {
          <a
            class="quick-link"
            [routerLink]="link.route">
            <mat-icon class="quick-link__icon" aria-hidden="true">{{ link.icon }}</mat-icon>
            <span class="quick-link__label">{{ link.label }}</span>
            <span class="quick-link__description">{{ link.description }}</span>
          </a>
        }
      </section>
    }
    @if (dashboardModel.showInvitationSection) {
      <div class="analytics-dashboard__divider" role="separator">
        <span>Invitations</span>
        <span class="analytics-dashboard__divider-meta">Last 4 weeks</span>
      </div>
    }
    @if (dashboardModel.showInvitationSection) {
      <section class="analytics-dashboard__invitations" aria-label="BB invitation status">
        <article class="invitation-card">
          <header class="invitation-card__head">
            <div>
              <h3 class="invitation-card__title">BB invitations</h3>
              <p class="invitation-card__subtitle">{{ dashboardModel.invitationScopeLabel }}</p>
            </div>
            <mat-icon class="invitation-card__icon" aria-hidden="true">outgoing_mail</mat-icon>
          </header>
          <div class="invitation-card__metrics">
            @for (metric of bbInvitationMetrics; track metric) {
              <div
                class="invitation-stat"
                [class]="'invitation-stat invitation-stat--' + metric.tone">
                <span class="invitation-stat__value">{{ metric.getValue() | number }}</span>
                <span class="invitation-stat__label">{{ metric.label }}</span>
              </div>
            }
          </div>
        </article>
      </section>
    }
    @if (dashboardModel.showParticipantGrowthSection) {
      <div class="analytics-dashboard__divider" role="separator">
        <span>Participant growth</span>
      </div>
    }
    @if (dashboardModel.showParticipantGrowthSection) {
      <section class="growth-panel" aria-label="Participant growth">
        <div class="growth-panel__content">
          <h3 class="growth-panel__title">New BB coached participants</h3>
          <div class="growth-panel__periods" role="group" aria-label="Time period">
            @for (option of periodOptions; track option) {
              <button
                type="button"
                class="growth-panel__period"
                [class.growth-panel__period--active]="drpCoachParticipantValue === option.value"
                (click)="setPeriod(option.value)">
                {{ option.label }}
              </button>
            }
          </div>
          @if (showGrowthEmptyHint) {
            <p class="growth-panel__hint">No participants — try a longer range</p>
          }
        </div>
        <div class="growth-panel__stat">
          <span class="growth-panel__value">{{ coachedParticipantCount | number }}</span>
        </div>
      </section>
    }
  </div>
}
